import { render, staticRenderFns } from "./AppSnackbars.vue?vue&type=template&id=6cc3bcac"
import script from "./AppSnackbars.vue?vue&type=script&lang=ts"
export * from "./AppSnackbars.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports